module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "main"
  }, [(!_vm.isCollapse && _vm.$wxOpenId) ? _c('i', {
    staticClass: "el-icon-s-fold button",
    on: {
      "click": function($event) {
        _vm.isCollapse = !_vm.isCollapse;
        _vm.toggle()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isCollapse && _vm.$wxOpenId) ? _c('i', {
    staticClass: "el-icon-s-unfold button",
    on: {
      "click": function($event) {
        _vm.isCollapse = !_vm.isCollapse;
        _vm.toggle()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$wxOpenId) ? _c('aside', {
    staticClass: "sidebar",
    class: _vm.isCollapse ? 'collapse' : ''
  }, [_c('ul', _vm._l((_vm.secendNode), function(item, index) {
    return (!item.hidden && !item.leaf) ? _c('li', {
      staticClass: "li1"
    }, [_c('div', {
      staticClass: "li1title"
    }, [_c('span', [_c('img', {
      attrs: {
        "src": item.icon
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "li1titletext"
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('ul', {
      staticClass: "ul2"
    }, _vm._l((item.children), function(child) {
      return (!child.hidden) ? _c('li', {
        staticClass: "li2",
        class: {
          'active': _vm.$route.path == child.path
        },
        on: {
          "click": function($event) {
            return _vm.$router.push(child.path)
          }
        }
      }, [_vm._v("\n                        " + _vm._s(child.name) + "\n                    ")]) : _vm._e()
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "bootmline"
    })]) : _vm._e()
  }), 0)]) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "content-container",
    class: _vm.$wxOpenId ? "" : "wx-content-container"
  }, [_c('el-col', {
    staticClass: "breadcrumb-container",
    attrs: {
      "span": 24
    }
  }, [_c('el-breadcrumb', {
    staticClass: "breadcrumb-inner",
    attrs: {
      "separator": "/"
    }
  }, _vm._l((_vm.$route.matched), function(item) {
    return _c('el-breadcrumb-item', {
      key: item.path
    }, [_vm._v("\n                    " + _vm._s(item.name) + "\n                ")])
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    ref: "contentWrapper",
    staticClass: "content-wrapper",
    attrs: {
      "span": 24
    }
  }, [_c('router-view')], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13ce559a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Navigation.vue
// module id = 1645
// module chunks = 471